import { render, staticRenderFns } from "./InfoCardVisits.vue?vue&type=template&id=367be4de&scoped=true&"
import script from "./InfoCardVisits.vue?vue&type=script&lang=js&"
export * from "./InfoCardVisits.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardVisits.vue?vue&type=style&index=0&id=367be4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367be4de",
  null
  
)

export default component.exports